angular.module('env.events', [])

    .constant('EventingMixin', (function EventingMixin(eventNames) {

            /**
             * Event name to event handlers array hash
             */
            var _handlers = {};

            _.each(eventNames, function (el) {
                _handlers[el] = [];
            });

            /**
             * Subscribe to an event
             * @param {string} eventName name of the event
             * @param {function} eventHandler event handler
             */
            function on(eventName, eventHandler) {
                if (_.isArray(eventName)) {
                    _.forEach(eventName, function (ename) {
                        on(ename, eventHandler);
                    });
                } else {
                    if (!_handlers[eventName]) {
                        _handlers[eventName] = [];
                    }
                    if (!_.any(_handlers[eventName], function (h) {
                        return h === eventHandler;
                    })) {
                        _handlers[eventName].push(eventHandler);
                    }
                    return unSubscribe(eventName, eventHandler);
                }
            }

            function unSubscribe(eventName, handler) {
                return function () {
                    if (_handlers && _handlers[eventName]) {
                        _handlers[eventName] = _.filter(_handlers[eventName], function (h) {
                            return h !== handler;
                        });
                    }
                }
            }

            /**
             * Raise event
             * @param {string} eventName name of the event
             * @param args event arguments
             */
            function raise(eventName, args) {
                if (_.isArray(eventName)) {
                    _.forEach(eventName, function (en) {
                        raise(en, args);
                    });
                }

                if (!_handlers[eventName]) {
                    return;
                }
                _.each(_handlers[eventName], function (handler) {
                    handler(args);
                });
            }

            function getEvents() {
                return _.keys(_handlers);
            }

            this.events = {
                on: on,
                raise: raise,
                getEvents: getEvents
            };
        })
    );